import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNotifications = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-0.75 0 23.35 24.5",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M1.724 9.949a9.2 9.2 0 0 1 18.4 0v7.474a1.725 1.725 0 0 0 1.725 1.725H0a1.725 1.725 0 0 0 1.725-1.725Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M13.741 21.449a2.875 2.875 0 0 1-5.634 0" }),
			/* @__PURE__ */ _jsx("path", {
				strokeLinejoin: "round",
				d: "M13.799 4.74a5.176 5.176 0 0 1 2.874 4.635"
			})
		]
	})
});
export { SvgIconNotifications as ReactComponent };
